import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("mask", {
			id: "path-1-inside-1_682_345",
			fill: "white",
			children: /* @__PURE__ */ _jsx("path", { d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 10M20 10M20 10M0 10M10 0M20 10M10 20M0 10M10 20V18.5C5.30558 18.5 1.5 14.6944 1.5 10H0H-1.5C-1.5 16.3513 3.64873 21.5 10 21.5V20ZM20 10H18.5C18.5 14.6944 14.6944 18.5 10 18.5V20V21.5C16.3513 21.5 21.5 16.3513 21.5 10H20ZM10 0V1.5C14.6944 1.5 18.5 5.30558 18.5 10H20H21.5C21.5 3.64873 16.3513 -1.5 10 -1.5V0ZM10 0V-1.5C3.64873 -1.5 -1.5 3.64873 -1.5 10H0H1.5C1.5 5.30558 5.30558 1.5 10 1.5V0Z",
			fill: "#212629",
			mask: "url(#path-1-inside-1_682_345)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 7C10.8284 7 11.5 6.32843 11.5 5.5C11.5 4.67157 10.8284 4 10 4C9.17157 4 8.5 4.67157 8.5 5.5C8.5 6.32843 9.17157 7 10 7Z",
			fill: "#212629"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 16V9",
			stroke: "#212629",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgInfo;
